export const CHART_COLORS = [
  // Base colors from user
  '#7856FE', // Purple
  '#FF7556', // Coral
  '#81E1DA', // Teal
  '#F8BB3C', // Yellow
  '#B2586E', // Muted Pink
  '#72BEF4', // Blue
  '#FFB27A', // Light Orange
  // Expanded variations and complementary colors
  '#A78BFA', // Light Purple (variation of #7856FE)
  '#FF9F7A', // Soft Coral (variation of #FF7556)
  '#5DDBCE', // Deep Teal (variation of #81E1DA)
  '#E6A532', // Deep Yellow (variation of #F8BB3C)
  '#9A4B5C', // Deep Pink (variation of #B2586E)
  '#5BA7E8', // Deep Blue (variation of #72BEF4)
  '#FF9B5E', // Orange (variation of #FFB27A)
  '#6B46C1', // Dark Purple
  '#DC2626', // Red
  '#059669', // Green
  '#7C2D12', // Brown
  '#0891B2', // Cyan
  '#84CC16', // Lime
  '#EC4899', // Bright Pink
];
